import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=c7c35b6e&scoped=true&"
import script from "./AreaList.vue?vue&type=script&lang=js&"
export * from "./AreaList.vue?vue&type=script&lang=js&"
import style0 from "./AreaList.vue?vue&type=style&index=0&id=c7c35b6e&prod&lang=scss&scoped=true&"
import style1 from "./AreaList.vue?vue&type=style&index=1&id=c7c35b6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c35b6e",
  null
  
)

export default component.exports